module.exports = __webpack_public_path__ + "images/corporate_mobile_icon-a7b39aa110b769f8af88e77317d1b725.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/corporate_mobile_icon.png
// module id = ./client/assets/images/corporate_mobile_icon.png
// module chunks = 86